<template>
  <div>
    <div
      class="card page mb-5 p-2"
      style="width: 1300px; margin: 0 auto; box-shadow: 10px 10px 5px #888888"
      id="v-content"
    >
      <p>
        <span
          class="float-right span_close"
          style="
            display: block;
            width: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 25px;
          "
          @click="$router.go(-1)"
        >
          &times;
        </span>
      </p>
      <div style="margin: 0 auto; width: 1000px">
        <el-select
          v-model="bumenid"
          placeholder="请选择部门"
          @change="getPfList"
        >
          <el-option
            v-for="item in options"
            :key="item.bumen"
            :label="item.bumen"
            :value="item.bumenid"
          >
          </el-option>
        </el-select>
        <!-- <select
          v-model="bumen"
          style="width: 200px; margin-bottom: 20px"
          @click="Getbmpj()"
          class="form-control"
        >
          <option value="">请选择部门</option>
          <option
            v-for="(item, index) in options"
            :key="index"
            :value="item.bumenid"
            v-text="item.bumen"
          ></option>
        </select> -->
        <!-- <table class="table table-striped table-hover">
          <tr class="text-center" style="font-size: 20px">
            <th>部门名称</th>
            <th>职位</th>
            <th>姓名</th>
            <th>评议等级</th>
            <th>留言</th>
          </tr>
          <tr v-for="(item, index) in pjList" :key="index" class="text-center">
            <td style="vertical-align: middle;">
              {{ item.bumen}}
            </td>
            <td >
              {{ item.jobs }}
            </td>
            <td style="vertical-align: middle">{{ item.truename }}</td>
            <td style="vertical-align: middle">{{ }}</td>
            <td style="vertical-align: middle">{{ item.context }}</td>
          </tr>
        </table> -->
        <el-tabs style="margin-top:20px;" type="border-card" @tab-click="handleClick" v-model="activeName">
          <el-tab-pane label="人员评价" name="GetPjList">
            <el-table
              :data="pjList"
              style="width: 100%; margin-top: 20px"
              border
            >
              <el-table-column prop="bumen" label="部门名称" width="150" header-align="center">
              </el-table-column>
              <el-table-column prop="truename" label="姓名" width="100" header-align="center">
              </el-table-column>
              <el-table-column prop="jobs" label="职位" width="100" header-align="center">
              </el-table-column>
              <el-table-column prop="pf" label="评议等级" width="200" header-align="center">
                <template slot-scope="scope">
                  <div>
                    <el-rate
                      v-model="scope.row.pf"
                      show-text
                      :texts="texts"
                      :colors="colors"
                      :max="4"
                      text-color="red"
                    >
                    </el-rate>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="context" label="留言" header-align="center">
                <template slot-scope="scope">
                  <div>
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="请输入内容"
                      v-model="scope.row.context"
                      @blur="handle(scope.row)"
                    >
                    </el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-row
              :gutter="20"
              type="flex"
              justify="end"
              style="margin-top: 20px"
            >
              <el-button type="primary" @click="submit">提交评价</el-button>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="已评价" name="GetPjListed">
            <el-table
              :data="pjListed"
              border
              style="width: 100%;margin-top:20px;">
              <el-table-column
                prop="bumenname"
                label="部门名称"
                width="120" header-align="center">
              </el-table-column>
              <el-table-column
                prop="truename"
                label="姓名"
                width="100" header-align="center">
              </el-table-column>
              <el-table-column
                prop="jobs"
                label="职位"
                width="100" header-align="center">
              </el-table-column>
              <el-table-column
                prop="pf"
                label="评分"
                width="180" header-align="center">
                <template slot-scope="scope">
                  <div>
                    <el-rate
                      v-model="scope.row.pf"
                      show-text
                      :texts="texts"
                      :max="4"
                      disabled
                      :colors="colors"
                      text-color="red"
                    >
                    </el-rate>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="context"
                label="留言" header-align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                <div>
                  {{scope.row.context?scope.row.context:'暂无留言'}}
                </div>
              </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

        <!-- <P class="mb-5 text-right" style="font-size: 20px">
          <span class="mr-5">
            <span style="color: green">
              {{ sumpeople }}
            </span>
            人评价
          </span>
          <span> 合计分: </span>
          <span class="mr-5" style="color: red; font-size: 25px">
            {{ sumpf }}分
          </span>
          <span> 平均分: </span>
          <span style="color: red; font-size: 30px"> {{ pjf }}分 </span>
        </P> -->
      </div>
    </div>
  </div>
</template>

<script>
import rater from "w-rater";
export default {
  data() {
    return {
      pjList: [],
      pjListed:[],
      bumenid: "",
      options: [],
      pjf: "",
      sumpf: "",
      sumpeople: "",
      texts: ["不称职", "基本称职", "称职", "优秀"],
      activeName:'GetPjList',
      colors: ['#99A9BF', '#F7BA2A', '#FF9900']
    };
  },
  components: {
    rater,
  },
  methods: {
    getGs() {
      this.$http.post("Evaluate/GetGS", {}).then((res) => {
        if (res.data.isok) {
          this.options = [
            {
              bumen: "全部",
              bumenid: -1,
            },
            ...res.data.data,
          ];
        }
      });
    },
    getPfList() {
      if(this.activeName=="GetPjList"){
        this.searchPfList()
      }else if(this.activeName=="GetPjListed"){
        this.searchPfListed()
      }
    },
    searchPfList(){
      let bumenid = this.bumenid ? this.bumenid : -1;
      this.$http
        .post("Evaluate/GetPjList", {
          bumenid,
        })
        .then((res) => {
          // console.log(res.data)
          this.pjList = res.data.data.map((item) => {
            // console.log(item)
            item.pf = 0;
            item.context = "";
            return item;
          });
          // console.log(this.pjList)
        });
    },
    searchPfListed(){
      this.$http
        .post("Evaluate/GetPjListed", {
        })
        .then((res) => {
          this.pjListed = res.data.data
        });
    },
    handle(rows) {
      // console.log(rows)
      if (rows.pf === 0) {
        this.$alert("对不起，您还没有评分", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          callback: (action) => {
            rows.context = "";
          },
        });
      }
    },
    handleClick(tab){
      if(tab.name=="GetPjList"){
        this.searchPfList()
      }else{
        this.searchPfListed()
      }
    },
    submit() {
      let arr = this.pjList.filter((item) => {
        return item.pf > 0;
      });
      let listobjs = arr.map((item) => {
        let obj = {};
        obj.bumenname = item.bumen;
        obj.bumenid = item.bumenid;
        obj.pf = item.pf;
        obj.context = item.context;
        obj.userid = item.id;
        obj.truename = item.truename;
        return obj;
      });
      this.$http
        .post("Evaluate/AddPj", {
          listobjs,
        })
        .then((res) => {
          // console.log(res.data)
          if (res.data.isok) {
            this.$message.success("提交评价成功！");
            this.searchPfList();
          }
        });
    },
  },
  created() {
    this.getGs();
    this.searchPfList();
  },
};
</script>

<style >
.el-table th {
  background-color: #eef1f6;
}
</style>



// WEBPACK FOOTER //
// src/pages/Pj/NewEvaluate.vue